<p>create-cf-inquiry-popup works!</p>
